import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEarthEu = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_10799_12396)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.0001 6.26074L16.5181 7.85505H18.1944L16.8382 8.84037L17.3563 10.4347L16.0001 9.4493L14.6438 10.4347L15.1619 8.84037L13.8057 7.85505H15.482L16.0001 6.26074Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.11338 9.1137L10.6071 9.8747L11.7924 8.68945L11.5301 10.3451L13.0238 11.1061L11.3681 11.3684L11.1059 13.0241L10.3448 11.5305L8.68919 11.7928L9.87451 10.6075L9.11338 9.1137Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.26094 16L7.85525 15.482V13.8057L8.8405 15.1619L10.4349 14.6439L9.44944 16L10.4349 17.3562L8.8405 16.8382L7.85525 18.1944V16.5181L6.26094 16Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.11338 22.8869L9.87444 21.3932L8.68919 20.2079L10.3449 20.4703L11.1058 18.9766L11.3681 20.6322L13.0238 20.8945L11.5303 21.6556L11.7924 23.3112L10.6071 22.1259L9.11338 22.8869Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.0001 25.7392L15.4819 24.1449H13.8057L15.1619 23.1596L14.6438 21.5654L16.0001 22.5507L17.3563 21.5654L16.8382 23.1596L18.1944 24.1449H16.5181L16.0001 25.7392Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.8867 22.8869L21.393 22.1259L20.2076 23.3113L20.4699 21.6555L18.9764 20.8945L20.632 20.6322L20.8943 18.9766L21.6553 20.4703L23.3109 20.2079L22.1256 21.3933L22.8867 22.8869Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.7391 16L24.1448 16.5181V18.1944L23.1595 16.8382L21.5653 17.3562L22.5506 16L21.5653 14.6439L23.1596 15.1619L24.1448 13.8057V15.482L25.7391 16Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.8867 9.11364L22.1256 10.6074L23.3109 11.7927L21.6552 11.5303L20.8943 13.024L20.632 11.3683L18.9764 11.106L20.4699 10.345L20.2076 8.68945L21.3931 9.8747L22.8867 9.11364Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_10799_12396",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}) })]
});
export default SvgEarthEu;
